<script>
import { mapActions } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default {
  props: {
    branchId: {
      type: String,
      default: null,
    },
    scheduleId: {
      type: String,
      default: null,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorScheme() {
      return this.isActive ? 'alert' : 'success';
    },
  },
  methods: {
    ...mapActions('appointments', ['toggleSchedule', 'fetchScheduleList']),
    async handleToggleSchedule() {
      try {
        await this.toggleSchedule({
          scheduleId: this.scheduleId,
          branchId: this.branchId,
          toggle: this.isActive ? 'deactivate' : 'activate',
        });
      } catch (err) {
        console.error(err);
        useAlert(err);
      } finally {
        this.fetchScheduleList(this.branchId);
      }
    },
  },
};
</script>

<template>
  <woot-button
    variant="smooth"
    :color-scheme="colorScheme"
    icon="plus-sign"
    @click="handleToggleSchedule()"
  >
    {{ isActive ? $t('BRANCHES.TOGGLE_SCHEDULE_BUTTON.DEACTIVATE') : $t('BRANCHES.TOGGLE_SCHEDULE_BUTTON.ACTIVATE') }}
    {{ $t('BRANCHES.TOGGLE_SCHEDULE_BUTTON.SCHEDULE') }}
  </woot-button>
</template>
